export default __webpack_public_path__ + "static/media/grafema_ummi_17.bb507a59.jpg";